<template>
  <div :class="outputObject.success ?  'Twilio' : 'Twilio__error' ">
    <div class="Twilio__header">
      <span>Messages</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && outputObject.success">
      <div v-if="isValidJson" class="Twilio__body">
        <div class="Twilio__messages">
          <div v-for="message in outputObject.data" :key="message.id" class="Twilio__messages-container">
              <div class="Twilio__message-header">
                <strong>{{ message.dateSent }}. {{ message.status }}</strong>
              </div>
              <div class="Twilio__message-content">
                <div>{{ message.body }}</div>
              </div>
              <div v-if="message.errorMessage" class="Twilio__error-info">
                <strong>Error:</strong> {{ message.errorMessage }}
              </div>
              <div class="Twilio__message-details">
                <div class="Twilio__detail-item">
                  <span>Cost: {{ Math.abs(message.price) }} {{ message.priceUnit }}</span>
                </div>
              </div>
          </div>
        </div>
        <json-viewer
            :expand-depth=0
            :value="outputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="Twilio__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !outputObject.success">
      <div class="Twilio__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'twilio-list-sms-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      if(!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
